import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD8x9O164h9gXxcEMW0cqzkNY8U_ZdheyA",
  authDomain: "data-axe-401820.firebaseapp.com",
  projectId: "data-axe-401820",
  storageBucket: "data-axe-401820.firebasestorage.app",
  messagingSenderId: "124679488593",
  appId: "1:124679488593:web:46cee148186743cd6ea470",
  measurementId: "G-XR5LQDXYB6"
};

const app = initializeApp(firebaseConfig);

// Export Firestore database instance for advisors management
export const db = getFirestore(app, 'prd-advisors-management');